export enum UserTypes {
  SUPER_ADMIN = "super_admin",
  BUSINESS_CUSTOMER = "business_customer",
  PERSONAL_CUSTOMER = "personal_customer",
  DRIVER = "driver",
  DISPATCH = "dispatch",
}
